import { DateTime, Duration } from 'luxon'
import { useState } from 'react'

import { useInterval } from 'src/lib/hooks/use-interval'

const refreshRate = Duration.fromObject({ seconds: 1 }).as('milliseconds')
const timeoutDuration = Duration.fromObject({ hours: -1 })

// Pure version, no React hook
export function hasTimedOut(
  updatedAt: string,
  now: DateTime = DateTime.local()
) {
  const lastUpdate = DateTime.fromISO(updatedAt)
  return lastUpdate.diff(now, ['milliseconds']) < timeoutDuration
}

// existing hook, now delegating to hasTimedOut
export function useTimedOut(updatedAt: string) {
  const [now, setNow] = useState(DateTime.local())

  useInterval(() => {
    setNow(DateTime.local())
  }, refreshRate)

  return hasTimedOut(updatedAt, now)
}
